module.exports = __webpack_public_path__ + "img/Holi 2.651aad90.jpeg";